import React from "react";

const InformationCard = ({ feature, customClassName = "" }) => {
  return (
    <div className={`bg-white rounded-xl shadow-lg p-6 text-center hover:shadow-xl transition-shadow duration-300 ${customClassName}`}>
      <div className="flex justify-center mb-4 text-primary">
        {feature.icon}
      </div>
      <h3 className="text-xl font-bold text-heading mb-3">
        {feature.title}
      </h3>
      <p className="text-gray-600 leading-relaxed">
        {feature.description}
      </p>
    </div>
  );
};

export default InformationCard;
